import axios from "axios";
import { API_BASE_URL } from "../constants";

const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem(
        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
    )}`,
});

/**
 * HTTP 400 body uses `message` as a field → string map.
 * Returns `{}` when the error is not that envelope.
 */
export const getDataFlowV2FieldErrors = (error) => {
    const message = error?.response?.data?.message;

    if (message && typeof message === "object" && !Array.isArray(message)) {
        return message;
    }

    return {};
};

export default class DataFlowV2Service {
    static instance;

    static getInstance() {
        if (!DataFlowV2Service.instance) {
            DataFlowV2Service.instance = new DataFlowV2Service();
        }

        return DataFlowV2Service.instance;
    }

    async getOptions() {
        const response = await axios.get(`${API_BASE_URL}/data_flow/options`, {
            headers: authHeaders(),
        });

        return response.data;
    }

    async getSoftwareDataFlows(softwareId) {
        const response = await axios.get(
            `${API_BASE_URL}/software/${softwareId}/data_flows/v2`,
            {
                headers: authHeaders(),
            }
        );

        return response.data;
    }

    async createDataFlow(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/data_flow/create`,
            payload,
            {
                headers: authHeaders(),
            }
        );

        return response.data;
    }

    async updateDataFlow(id, payload) {
        const response = await axios.post(
            `${API_BASE_URL}/data_flow/${id}/update`,
            payload,
            {
                headers: authHeaders(),
            }
        );

        return response.data;
    }

    async deleteDataFlow(id) {
        const response = await axios.delete(
            `${API_BASE_URL}/data_flow/${id}/delete`,
            {
                headers: authHeaders(),
            }
        );

        return response.data;
    }

    async listEndpoints({ q = "", type = "", limit = 25, offset = 0 } = {}) {
        const response = await axios.get(
            `${API_BASE_URL}/data_flow_endpoint/list`,
            {
                params: { q, type, limit, offset },
                headers: authHeaders(),
            }
        );

        return response.data;
    }

    async createEndpoint(payload) {
        const response = await axios.post(
            `${API_BASE_URL}/data_flow_endpoint/create`,
            payload,
            {
                headers: authHeaders(),
            }
        );

        return response.data;
    }

    async updateEndpoint(id, payload) {
        const response = await axios.post(
            `${API_BASE_URL}/data_flow_endpoint/${id}/update`,
            payload,
            {
                headers: authHeaders(),
            }
        );

        return response.data;
    }

    async getSoftwareAssets() {
        const response = await axios.get(
            `${API_BASE_URL}/asset/index?type=software`,
            {
                headers: authHeaders(),
            }
        );

        return response.data;
    }

    async getHardwareAssets() {
        const response = await axios.get(
            `${API_BASE_URL}/asset/index?type=hardware`,
            {
                headers: authHeaders(),
            }
        );

        return response.data;
    }
}
